module.exports = __webpack_public_path__ + "static/img/aepic-16.d7ec5bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-16.jpg
// module id = Lbyy
// module chunks = 52